<template>
  <v-autocomplete
    hide-details="auto"
    :items="Purchase"
    :loading="loading"
    v-model="selectedPurchase"
    item-text="reference_number"
    item-value="id"
    label="Purchase Reference Number"
    clearable
    outlined
    dense
    @change="emitInput"
    :search-input.sync="searchPurchase"
  ></v-autocomplete>
</template>
<script>
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
    DefaultPurchaseVisble: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    Purchase: [],
    selectedShop: null,
    searchPurchase: null,
    loading: false,
  }),
  methods: {
    emitInput() {
      this.$emit('input', this.selectedPurchase);
    },
    getPurchaseByQuery(query = '') {
      this.loading = true;
      this.$store
        .dispatch('purchase/GetPurchaseSearch', {
          query: query,
          status: 'active',
        })
        .then((res) => {
          this.Purchase = res;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectedPurchase = null;
      },
      deep: true,
    },
    searchPurchase: {
      handler(val) {
        this.getPurchaseByQuery(val);
      },
      deep: true,
    },
  },
  created() {
    if (this.DefaultPurchaseVisble) {
      this.selectedPurchase = 1;
    }
    this.getPurchaseByQuery();
  },
};
</script>
